import profile from '../images/profile.jpg';
import squares from '../store/Squares';

export default {
    "name": "Message",
    "title": "Send a Message",
    "links": ['Blog', 'Home'],
    "images": {
        "profile": profile,
    },
    "squares": squares,
    "background": "backgroundMessage",
};